

export const exercises = [
  {
    videoSrc: "Cardio Circuit.mp4",
    thumbnailSrc: "The Champion.jpg",
    audioSrc: "The champion.m4a",
    thumbnailTimestamp: 8,
    title: 'The Champion',
    // Tagline mapped to description
    description: 'Get your heart pumping and move like the champion you are! A great exercise routine to build functional strength, endurance, coordination and improve overall wellbeing',
    // Recommended Dose
    dose: 'Repeat each movement 5 to 10 times. After 1 round, rest and repeat for another 2 to 3 rounds.',
    // Script
    script: "Put your hands up! Punch forward, upper cut! Punch the sky! Now punch across. Now let's go, move your legs like they are a pair of scissors! Now let's do flutter kicks, keep those legs moving like you are a swimmer! Let's hold and push, use those legs! Now let's row that boat. Kick to the sides, and finish with crunches, opposite knee to elbow. You are strong, you are amazing, You are a champion!",
    duration: '1 min 8 sec',
    difficulty: 'Intermediate',
    category: ['Chair Exercises', 'Wellness', 'Strengthening', 'Beat'],
    goalIntent: ['Strengthen Full Body', 'Increase Mobility', 'Improve Endurance', 'Cardiovascular Fitness', 'Increase Energy'],
    symptomFeeling: ['Fatigue / Low Energy', 'Stiffness', 'Feeling Unfit', 'Sedentary', 'Poor Circulation'],
    bodyPart: ['Full Body', 'Arms', 'Legs', 'Core', 'Heart / Lungs'],
    activityContext: ['Chair Exercises', 'Senior Fitness', 'Warm-up', 'Daily Routine', 'Quick Workout'],
    exerciseType: ['Cardio (Light)', 'Strengthening', 'Mobility', 'Chair Exercises', 'Circuit Training'],
    difficultyIntensity: ['Low-Impact', 'Intermediate', 'Senior-Friendly', 'Adaptable Intensity']
  },
  {
    videoSrc: "Cut The Fruit.mp4",
    audioSrc: "The Mango party.m4a",
    thumbnailSrc: "The Mango Party.jpg",
    thumbnailTimestamp: 5,
    title: 'The Mango Party',
    description: 'Stretch your back, twist your spine, and share some happiness. A great exercise to improve coordination, flexibility and overall wellbeing. ',
    dose: 'Repeat the full sequence 5 times.',
    script: "Reach high to pick the mango! Chop it down! Twist to the right, give a slice to your neighbour. Twist to the left, give a slice to your friend. Now bend down and pick up all the pieces and throw it in the air, give a slice to everyone!",
    duration: '20 sec',
    difficulty: 'Beginner',
    category: 'Wellness, Beat, Breath, Injury Prevention',
    goalIntent: ['Increase Mobility', 'Increase Energy', 'Improve Coordination', 'Strengthen Core', 'Improve Flexibility'],
    symptomFeeling: ['Stiffness', 'Back Pain', 'Poor Posture', 'Fatigue / Low Energy', 'Dizziness / Vertigo'],
    bodyPart: ['Full Body', 'Spine / Back', 'Shoulders', 'Core', 'Obliques', 'Arms'],
    activityContext: ['Senior Fitness', 'Chair Exercises', 'Gardening', 'Household Chores', 'Morning Routine', 'Warm-up'],
    exerciseType: ['Mobility', 'Stretching', 'Core Stability', 'Chair Exercises', 'Breathing Exercises', 'Coordination'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly', 'Adaptable Intensity']
  },
  {
    videoSrc: "Down-Then-Up.mp4",
    audioSrc: "Earth and sky.m4a",
    thumbnailSrc: "Earth and Sky.jpg",
    thumbnailTimestamp: 6,
    title: 'Earth and Sky',
    description: 'Connect Earth and Sky to wake up your spine. A wonderful full body exercise to relieve morning stiffness',
    dose: 'Repeat 5 to 8 times slowly. Do not rush.',
    script: "Reach both hands down towards your feet—touch the Earth. Now, sweep your arms all the way up and reach for the Sky! Feel your spine getting longer.",
    duration: '44 sec',
    difficulty: 'Beginner',
    category: 'Wellness, Pain Management, Breath, Aspirational Goal',
    goalIntent: ['Reduce Stiffness', 'Increase Flexibility', 'Increase Energy', 'Improve Breathing', 'Improve Posture'],
    symptomFeeling: ['Back Stiffness', 'Lower Back Pain', 'Upper Back Pain', 'Slumped Posture', 'Lethargy'],
    bodyPart: ['Spine', 'Full Body', 'Lower Back', 'Upper Back', 'Shoulders'],
    activityContext: ['Morning Routine', 'Senior Fitness', 'Office Break', 'Warm-up', 'Relaxation'],
    exerciseType: ['Mobility', 'Stretching', 'Chair Exercises', 'Breathing Exercises', 'Flexibility'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly', 'Rehab']
  },
  {
    videoSrc: "Forward and Back.mp4",
    audioSrc: "The seated cha-cha.m4a",
    thumbnailSrc: "The Seated Cha-Cha.jpg",
    thumbnailTimestamp: 7,
    title: 'The Seated Cha-Cha',
    description: 'Wake up your brain and improve your balance. A wonderful exercise to improve coordination, cardiovascular endurance and walking ability',
    dose: 'Try to keep the rhythm for 30 seconds.',
    script: "Cross your arms over your chest. Now, tap your feet: Right foot forward, Left foot forward. Right foot back, Left foot back. Find your rhythm! Cha-cha-cha.",
    duration: '18 sec',
    difficulty: 'Beginner',
    category: 'Wellness, Injury Prevention, Falls Prevention, Balance, Beat',
    goalIntent: ['Strengthen Legs', 'Improve Balance', 'Strengthen Core', 'Prepare for Activity'],
    symptomFeeling: ['Weakness', 'Poor Balance', 'Fear of Falling', 'Difficulty Walking', 'Hip Pain / Stiffness'],
    bodyPart: ['Hips', 'Legs', 'Core', 'Knee', 'Abs / Tummy'],
    activityContext: ['Walking', 'Stair Climbing', 'Senior Fitness', 'Chair Exercises', 'Getting Up from a Chair'],
    exerciseType: ['Strengthening', 'Balance Training', 'Chair Exercises', 'Core Stability', 'Cardio (Light)'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Rehab', 'Senior-Friendly']
  },
  {
        videoSrc: "Out and In.mp4",
        audioSrc: "The side step.m4a",
        thumbnailSrc: "The Side Step.jpg",
        thumbnailTimestamp: 12,
        title: 'The Side Step',
        description: 'Gentle hip-opening and closing exercise to improve mobility, reduce stiffness, and support hip strength.',
        duration: '19 sec',
        difficulty: 'Beginner',
        category: 'Wellness, Pain Management, Injury Prevention, Breath, Beat',
        goalIntent: ['Increase Mobility', 'Reduce Stiffness', 'Strengthen Legs', 'Prepare for Activity'],
        symptomFeeling: ['Hip Pain', 'Stiffness', 'Weakness', 'Arthritis', 'Groin Pain'],
        bodyPart: ['Hips', 'Inner Thigh / Groin', 'Outer Thigh / Hips', 'Pelvis', 'Legs'],
        activityContext: ['Senior Fitness', 'Chair Exercises', 'Sitting on Floor', 'Getting out of a Car', 'Warm-up', 'Desk Work Relief'],
        exerciseType: ['Mobility', 'Stretching', 'Strengthening', 'Chair Exercises', 'Bodyweight Exercise', 'Breathing Exercises', 'Cardio (Light)'],
        difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Rehab', 'Senior-Friendly']
  },
  {
    videoSrc: "Heel-Toe.mp4",
    audioSrc: "The see-saw.m4a",
    thumbnailSrc: "The See Saw.jpg",
    thumbnailTimestamp: 4,
    title: 'The See-Saw',
    description: 'Play The See-Saw with your feet to pump blood back to your heart. A great exercise to improve ankle movement and circulation. Try this whilst travelling in a car, bus or on a plane! ',
    dose: 'Keep rocking for 30 seconds continuously. Repeat for a total of 3 rounds.',
    script: "Keep your heels on the ground and lift your toes up. Now, put your toes down and lift your heels up. Rock back and forth—heels, toes, heels, toes.",
    duration: '22 sec',
    difficulty: 'Beginner',
    category: 'Wellness, Pain Management, Injury Prevention, Post Operation',
    goalIntent: ['Improve Circulation', 'Improve Mobility', 'Reduce Swelling', 'Reduce Stiffness', 'Prepare for Activity'],
    symptomFeeling: ['Ankle Stiffness', 'Foot Pain', 'Poor Circulation', 'Swollen Ankles', 'Leg Cramps'],
    bodyPart: ['Ankles', 'Feet', 'Lower Legs', 'Calves', 'Shins'],
    activityContext: ['Senior Fitness', 'Prolonged Sitting', 'Walking', 'TV Watching', 'Travel'],
    exerciseType: ['Mobility', 'Chair Exercises', 'Stretching', 'Warm-up', 'Rehab'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Rehab', 'Senior-Friendly']
  },
  {
    videoSrc: "Inhale-Exhale.mp4",
    audioSrc: "The flying bird.m4a",
    thumbnailSrc: "The Flying Bird.jpg",
    thumbnailTimestamp: 10,
    title: 'The Flying Bird',
    description: 'Open your lungs and let the fresh air in. A very good exercise to improve lung capacity.',
    dose: 'Repeat 5 to 8 deep breaths. Perform twice a day.',
    script: "Sit comfortably and close your eyes. As you breathe in deeply, raise your arms up slowly like the wings of a bird. As you breathe out, lower your wings gently. Fill your chest with fresh energy.",
    duration: '21 sec',
    difficulty: 'Beginner',
    category: 'Breath, Wellness',
    goalIntent: ['Improve Breathing', 'Reduce Stress', 'Relaxation', 'Improve Mobility', 'Increase Energy'],
    symptomFeeling: ['Shallow Breathing', 'Breathlessness', 'Anxiety'],
    bodyPart: ['Shoulders', 'Upper Back', 'Chest', 'Lungs', 'Full Body'],
    activityContext: ['Morning Routine', 'Relaxation', 'Senior Fitness', 'Office Break', 'Desk Job'],
    exerciseType: ['Breathing Exercises', 'Chair Exercises', 'Warm-up'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly']
  },
  {
    videoSrc: "Inhale-Exhale-Push.mp4",
    audioSrc: "The namaste push.m4a",
    thumbnailSrc: "The Namaste Push.jpg",
    thumbnailTimestamp: 6,
    title: 'The Namaste Push',
    description: 'Center yourself and push the stress away. A great exercise to Improve breath control and reduce body stress. ',
    dose: 'Repeat 8 to 10 times with slow, deep breaths.',
    script: "Bring your hands together in Namaste and breathe in deep. Now, as you breathe out, push your palms forward, pushing away any stress or heaviness from your chest.",
    duration: '21 sec',
    difficulty: 'Beginner',
    category: 'Breath, Wellness, Pain Management, Beat',
    goalIntent: ['Improve Breathing', 'Relaxation / Stress Relief', 'Increase Energy', 'Improve Focus / Mindfulness', 'Strengthen Upper Body'],
    symptomFeeling: ['Stress / Anxiety', 'Breathlessness', 'Fatigue / Low Energy', 'Poor Circulation', 'Tension'],
    bodyPart: ['Lungs / Diaphragm', 'Chest', 'Shoulders', 'Upper Back', 'Core', 'Arms'],
    activityContext: ['Breathing Practice', 'Meditation / Mindfulness', 'Senior Fitness', 'Chair Exercises', 'Warm-up', 'Cool-down', 'Office Exercises'],
    exerciseType: ['Breathing Exercises', 'Mindful Movement', 'Stretching', 'Strengthening', 'Chair Exercises'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly', 'Adaptable Intensity']
  },
  {
    videoSrc: "Knee Straighten.mp4",
    audioSrc: "The gentle kick.m4a",
    thumbnailSrc: "The Gentle Kick.jpg",
    thumbnailTimestamp: 8,
    title: 'The Gentle Kick',
    description: 'Oil your knee joints while you sit. A great exercise to improve knee movement, particularly for those with arthritis',
    dose: 'Do 8 to 10 kicks on the right leg, then 8 to 10 on the left. Complete 3 rounds on each leg.',
    script: "Lift one foot until your leg is straight. Squeeze the muscle on top of your thigh. Hold it there... and slowly lower it down. Let's make those knees strong.",
    duration: '24 sec',
    difficulty: 'Beginner',
    category: 'Pain Management, Injury Prevention, Post Operation',
    goalIntent: ['Strengthen Legs', 'Reduce Pain', 'Support Knees', 'Prepare for Activity', 'Improve Balance'],
    symptomFeeling: ['Knee Pain', 'Arthritis', 'Weakness', 'Unstable Knees', 'Difficulty Walking'],
    bodyPart: ['Knee', 'Thighs', 'Legs', 'Core'],
    activityContext: ['Knee Rehab', 'Senior Fitness', 'Stair Climbing', 'Walking', 'Getting Up From a Chair'],
    exerciseType: ['Strengthening', 'Chair Exercises', 'Mobility'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly']
  },
  {
    videoSrc: "Neck Circle.mp4",
    audioSrc: "The nose circle.m4a",
    thumbnailSrc: "The Nose Circle.jpg",
    thumbnailTimestamp: 6,
    title: 'The Nose Circle',
    description: 'Imagine drawing a zero in the air to gently loosen up. This is a good exercise to improve neck stiffness and mild pain',
    dose: 'Do 8 small circles clockwise, then 5 circles anti-clockwise.',
    script: "Imagine there is a pencil attached to the tip of your nose. Very gently, draw a small circle in the air. Keep the circle small and smooth. Now, draw it in the other direction.",
    duration: '19 sec',
    difficulty: 'Beginner',
    category: 'Wellness, Pain Management, Injury Prevention',
    goalIntent: ['Reduce Stiffness', 'Increase Mobility', 'Reduce Pain', 'Relaxation'],
    symptomFeeling: ['Neck Pain', 'Stiffness', 'Tension', 'Headaches', 'Dizziness / Vertigo'],
    bodyPart: ['Neck', 'Shoulders', 'Cervical Spine'],
    activityContext: ['Desk Work Relief', 'Reading Relief', 'Phone Use Relief', 'Morning Routine', 'Bedtime Routine', 'Senior Fitness', 'Office Exercises'],
    exerciseType: ['Mobility', 'Stretching', 'Chair Exercises'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly']
  },
  {
    videoSrc: "Sciatic Nerve Flossing.mp4",
    audioSrc: "The puppet string.m4a",
    thumbnailSrc: "The Puppet String.jpg",
    thumbnailTimestamp: 5,
    title: 'The Puppet String',
    description: 'Be like a puppet to gently glide the tension away. A wonderful exercise to stimulate and stretch the nervous system',
    dose: 'Do 10 smooth glides, have a 30 second rest then repeat for 1 more round.',
    script: "Imagine a string connects your nose to your toes. Look up and point your toes up. Look down and point your toes down. Keep the movement smooth and gentle.",
    duration: '28 sec',
    difficulty: 'Beginner',
    category: 'Pain Management, Wellness, Injury Prevention',
    goalIntent: ['Reduce Pain', 'Improve Nerve Mobility', 'Reduce Stiffness', 'Desensitise Nerve'],
    symptomFeeling: ['Sciatica', 'Nerve Pain', 'Tingling / Numbness', 'Hamstring Tightness', 'Lower Back Pain', 'Leg Pain'],
    bodyPart: ['Sciatic Nerve', 'Legs', 'Hamstrings', 'Lower Back', 'Nerves', 'Neck'],
    activityContext: ['Senior Fitness', 'Chair Exercises', 'Pain Relief Routine', 'Sitting for Long Periods', 'Rehab'],
    exerciseType: ['Nerve Flossing / Gliding', 'Mobility', 'Therapeutic Exercise', 'Chair Exercises', 'Bodyweight Exercise'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Rehab', 'Senior-Friendly']
  },
  {
    videoSrc: "Hamstring Stretch.mp4",
    audioSrc: "The gentle toe reach.m4a",
    thumbnailSrc: "The Gentle Toe Reach.jpg",
    thumbnailTimestamp: 9,
    title: 'The Gentle Toe Reach',
    description: 'Loosen up the back of your legs so putting on shoes is easy. A great exercise to improve leg flexibility and also mild back pain',
    dose: 'Hold the gentle stretch for 10 to 15 seconds. Repeat 3 times on each leg.',
    script: "Sit at the edge of your chair. Straighten one leg out with your heel on the floor. Keep your back straight and gently lean forward. Say hello to your toes!",
    duration: '53 sec',
    difficulty: 'Beginner',
    category: 'Pain Management, Wellness, Injury Prevention, Aspirational Goal',
    goalIntent: ['Increase Flexibility', 'Reduce Pain', 'Reduce Stiffness', 'Prepare for Activity', 'Improve Posture'],
    symptomFeeling: ['Lower Back Pain', 'Stiffness', 'Tight Hamstrings', 'Leg Pain', 'Difficulty Bending'],
    bodyPart: ['Hamstrings', 'Lower Back', 'Legs', 'Knee', 'Calves'],
    activityContext: ['Senior Fitness', 'Gardening', 'Walking', 'Cool-down', 'Sitting on Floor'],
    exerciseType: ['Stretching', 'Chair Exercises', 'Flexibility', 'Mobility', 'Cool-down'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Rehab', 'Senior-Friendly']
  },
  {
    videoSrc: "Seated Marching.mp4",
    audioSrc: "The chair walk.m4a",
    thumbnailSrc: "The Chair Walk.jpg",
    thumbnailTimestamp: 4,
    title: 'The Chair Walk',
    description: 'Do your morning walk safely from your sofa, a great exercise to improve cardiovascular endurance and walking ability.',
    dose: 'Continue steadily for 30 to 60 seconds. Rest, then repeat twice more.',
    script: "Sit tall in your chair. Lift your right knee, then your left knee. Swing your arms gently. Keep marching! 1, 2, 1, 2. Get the blood flowing in your legs.",
    duration: '12 sec',
    difficulty: 'Beginner',
    category: 'Wellness, Injury Prevention',
    goalIntent: ['Strengthen Legs', 'Improve Circulation', 'Stay Active While Sitting', 'Prepare for Activity', 'Increase Energy'],
    symptomFeeling: ['Weakness', 'Stiffness', 'Poor Circulation', 'Leg Pain', 'Arthritis'],
    bodyPart: ['Legs', 'Hips', 'Knees', 'Core', 'Thighs'],
    activityContext: ['Senior Fitness', 'Prolonged Sitting', 'Walking', 'Stair Climbing', 'TV Watching'],
    exerciseType: ['Strengthening', 'Cardio (Light)', 'Chair Exercises', 'Mobility', 'Warm-up'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Rehab', 'Senior-Friendly']
  },
  {
    videoSrc: "Seated Running.mp4",
    audioSrc: "The express train.m4a",
    thumbnailSrc: "The Express Train.jpg",
    thumbnailTimestamp: 15,
    title: 'The Express Train',
    description: "Get your arms and legs moving to wake up your whole body! Let's go for a run! A great exercise to improve cardiovascular health",
    dose: 'Go for 20 to 30 seconds. Rest for a minute, then try one more round.',
    script: "Start moving your arms and legs in a running motion like a slow train leaving the station. Chuk-chuk-chuk-chuk. Now go a little faster! Full speed express train! Keep going!",
    duration: '8 sec',
    difficulty: 'Beginner',
    category: 'Wellness, Beat, Injury Prevention, Breath',
    goalIntent: ['Increase Energy', 'Improve Heart Health', 'Improve Circulation', 'Prepare for Activity'],
    symptomFeeling: ['Breathlessness', 'Weakness', 'Fatigue / Low Energy', 'Knee Pain / Arthritis', 'Poor Circulation'],
    bodyPart: ['Full Body', 'Legs', 'Arms', 'Core', 'Heart / Lungs'],
    activityContext: ['Senior Fitness', 'Chair Exercises', 'Warm-up', 'Office Exercises', 'Indoor Activity', 'No-Impact Cardio'],
    exerciseType: ['Cardio (Light)', 'Chair Exercises', 'Warm-up Exercise', 'Bodyweight Exercise', 'Coordination'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly', 'Adaptable Intensity']
  },
  {
    videoSrc: "Shoulder Rolls.mp4",
    audioSrc: "The stress melter.m4a",
    thumbnailSrc: "The Stress Melter.jpg",
    thumbnailTimestamp: 6,
    title: 'The Stress Melter',
    description: 'Drop the weight of the world off your shoulders. A great exercise to improve neck and shoulder stiffness',
    dose: 'Do 10 big circles slowly then repeat in the opposite direction.',
    script: "Lift your shoulders up towards your ears—really high! Now roll them back and drop them down. Let all the tension melt away. Roll them round and round. Now repeat in the opposite direction.",
    duration: '13 sec',
    difficulty: 'Beginner',
    category: 'Wellness, Pain Management, Injury Prevention, Breath',
    goalIntent: ['Reduce Stiffness', 'Increase Mobility', 'Reduce Pain', 'Relaxation', 'Improve Posture'],
    symptomFeeling: ['Shoulder Pain', 'Neck Pain', 'Upper Back Pain', 'Stiffness', 'Tension', 'Poor Posture'],
    bodyPart: ['Shoulders', 'Neck', 'Upper Back', 'Scapula / Shoulder Blade'],
    activityContext: ['Desk Work Relief', 'Morning Routine', 'Warm-up', 'Senior Fitness', 'Office Exercises', 'Sitting for Long Periods'],
    exerciseType: ['Mobility', 'Stretching', 'Chair Exercises', 'Warm-up Exercise', 'Bodyweight Exercise'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Rehab', 'Senior-Friendly']
  },
  {
    videoSrc: "Turn and Hold.mp4",
    audioSrc: "The gentle twist.m4a",
    thumbnailSrc: "The_Gentle_Twist.jpg",
    thumbnailTimestamp: 10,
    title: 'The Gentle Twist',
    description: 'Loosen up your back to look behind you easily. A great exercise to improve spine rotation.',
    dose: 'Hold for 5 seconds. Repeat 3 times on each side.',
    script: "Place your right hand on your left knee. Gently turn your body to look over your left shoulder. Hold for a moment to squeeze out the stiffness. Now, let's switch sides.",
    duration: '33 sec',
    difficulty: 'Beginner',
    category: 'Wellness, Pain Management, Injury Prevention, Aspirational Goal',
    goalIntent: ['Improve Mobility', 'Reduce Stiffness', 'Reduce Pain', 'Improve Posture', 'Prepare for Activity'],
    symptomFeeling: ['Back Stiffness', 'Lower Back Pain', 'Mid Back Pain', 'Upper Back Pain', 'Waist Stiffness', 'Slumped Posture'],
    bodyPart: ['Spine', 'Upper Back', 'Mid Back', 'Lower Back', 'Core', 'Waist'],
    activityContext: ['Senior Fitness', 'Office Break', 'Driving', 'Household Chores', 'Warm-up'],
    exerciseType: ['Mobility', 'Stretching', 'Chair Exercises', 'Flexibility', 'Core Exercise'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly', 'Rehab']
  },
  {
    videoSrc: "Turn and Hug.mp4",
    audioSrc: "The big welcome.m4a",
    thumbnailSrc: "The Big Welcome.jpg",
    thumbnailTimestamp: 4,
    title: 'The Big Welcome',
    description: 'Open your arms and give yourself a squeeze.',
    dose: 'Repeat 8 times. Alternate which arm is on top and alternate the direction you are turning each time.',
    script: "Open your arms wide like you are welcoming a dear friend. Turn/rotate your body. Now, wrap your arms around yourself and give yourself a big hug. You deserve it!",
    duration: '30 sec',
    difficulty: 'Beginner',
    category: 'Wellness, Pain Management, Injury Prevention, Breath, Beat',
    goalIntent: ['Increase Mobility', 'Reduce Stiffness', 'Improve Posture', 'Relaxation'],
    symptomFeeling: ['Upper Back Pain', 'Shoulder Pain', 'Stiffness', 'Poor Posture / Slouching', 'Tension'],
    bodyPart: ['Spine / Back', 'Shoulders', 'Chest', 'Core', 'Obliques'],
    activityContext: ['Senior Fitness', 'Chair Exercises', 'Desk Work Relief', 'Morning Routine', 'Warm-up', 'Reaching Behind'],
    exerciseType: ['Mobility', 'Stretching', 'Core Stability', 'Chair Exercises', 'Breathing Exercises'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Rehab', 'Senior-Friendly']
  },
  {
    videoSrc: "Split Step Calf Raise.mp4",
    audioSrc: "The hill climber.m4a",
    thumbnailSrc: "The Hill Climber.jpg",
    thumbnailTimestamp: 4,
    title: 'The Hill Climber',
    description: 'Give your legs the power to push you upward. Another great exercise to improve functional leg strength and stability, particularly for the lower legs and ankles. One of the most important movements to improve walking ability and reduce the risk of falling',
    dose: 'Do 10 gentle pushes on the right foot, then 10 on the left.',
    script: "Step one foot back. Keep your front knee bent. Push your back toes into the ground and lift your heel high. Push off like you are walking up a hill.",
    duration: '30 sec',
    difficulty: 'Beginner',
    category: ['Strengthening', 'Falls Prevention', 'Balance', 'Wellness', 'Injury Prevention'],
    goalIntent: ['Strengthen Legs', 'Strengthen Ankles', 'Improve Balance', 'Improve Stability', 'Improve Circulation', 'Maintain Independence'],
    symptomFeeling: ['Poor Balance', 'Weakness', 'Ankle Instability', 'Fear of Falling', 'Poor Circulation', 'Leg Cramps', 'Unsteady Gait'],
    bodyPart: ['Calves / Lower Legs', 'Ankles', 'Feet'],
    activityContext: ['Walking', 'Stair Climbing', 'Senior Fitness', 'Home Exercises', 'Balance Training', 'Rehab'],
    exerciseType: ['Strengthening', 'Balance Training', 'Bodyweight Exercise', 'Supported Exercise', 'Calf Raise', 'Split Stance / Staggered Stance'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Rehab', 'Senior-Friendly']
  },
  {
    videoSrc: "Side to step + opp. hand up.mp4",
    audioSrc: "The shining star.m4a",
    thumbnailSrc: "The Shining Star.jpg",
    thumbnailTimestamp: 4,
    title: 'The Shining Star',
    description: 'Open your body to improve your balance and confidence. A great exercise to reduce your risk of falling, particularly when reaching for things.',
    dose: 'Hold for 5 seconds. Repeat 3 times on each side.',
    script: "Lift one leg out to the side. Reach the opposite arm up and out. Stretch your fingers! Shine bright like a star. Hold that balance.",
    duration: '30 sec',
    difficulty: 'Beginner',
    category: ['Falls Prevention', 'Balance', 'Strengthening', 'Wellness', 'Injury Prevention', 'Stretching'],
    goalIntent: ['Improve Balance', 'Improve Coordination', 'Strengthen Hips', 'Improve Stability', 'Maintain Independence', 'Increase Mobility', 'Gentle Side Stretch'],
    symptomFeeling: ['Poor Balance', 'Unsteady Gait', 'Fear of Falling', 'Weakness', 'Hip Instability', 'Side Body Stiffness', 'Core Weakness'],
    bodyPart: ['Full Body', 'Hips', 'Outer Thigh / Hips', 'Core', 'Obliques / Side Body', 'Shoulders', 'Legs'],
    activityContext: ['Walking', 'Reaching', 'Senior Fitness', 'Home Exercises', 'Balance Training', 'Rehab', 'Daily Living Activities'],
    exerciseType: ['Balance Training', 'Coordination', 'Strengthening', 'Stretching', 'Supported Exercise', 'Bodyweight Exercise', 'Lateral Movement / Side Step'],
    difficultyIntensity: ['Beginner', 'Low-Impact', 'Senior-Friendly', 'Rehab', 'Adaptable Intensity']
  },
  {
    videoSrc: "Tandem Stance.mp4",
    audioSrc: "The bamboo bridge.m4a",
    thumbnailSrc: "The Bamboo Bridge.jpg",
    thumbnailTimestamp: 4,
    title: 'The Bamboo Bridge',
    description: 'Cross the narrow bridge with focus and care.Another simple yet challenging balance exercise which is great to reduce your risk of falling',
    dose: 'Hold for 5 to 10 seconds, then switch feet. Repeat twice.',
    script: "Place one foot directly in front of the other, heel to toe. Imagine standing on a narrow bamboo bridge. Hold the chair if you need to! Stay steady.",
    duration: '30 sec',
    difficulty: 'Beginner',
    category: ['Falls Prevention', 'Balance', 'Strengthening', 'Wellness', 'Injury Prevention'],
    goalIntent: ['Improve Balance', 'Improve Stability', 'Maintain Independence', 'Improve Coordination', 'Strengthen Ankles', 'Strengthen Core', 'Improve Proprioception (Body Awareness)'],
    symptomFeeling: ['Poor Balance', 'Unsteady Gait', 'Fear of Falling', 'Ankle Instability', 'Dizziness / Vertigo'],
    bodyPart: ['Full Body', 'Ankles', 'Feet', 'Legs', 'Core'],
    activityContext: ['Senior Fitness', 'Home Exercises', 'Balance Training', 'Rehab', 'Daily Living Activities', 'Walking (Heel-to-Toe)'],
    exerciseType: ['Balance Training', 'Static Hold / Isometric', 'Bodyweight Exercise', 'Supported Exercise'],
    difficultyIntensity: ['Beginner (with support)', 'Low-Impact', 'Senior-Friendly', 'Rehab', 'Adaptable Difficulty']
  },
  {
    videoSrc: "Balance High Knee Opp. Hand.mp4",
    audioSrc: "The mountain climber.m4a",
    thumbnailSrc: "The Mountain Climber.jpg",
    thumbnailTimestamp: 4,
    title: 'The Mountain Climber',
    description: 'Reach high and step strong to build perfect balance. The best exercise to improve stability, balance and confidence. Work on your core strength as well as your legs!',
    dose: 'Hold for 3 seconds. Alternate sides for 20 total repetitions (10 each side).',
    script: "Lift one knee high in front of you. Take the opposite hand off the chair and reach up to the sky. Climb that mountain! Hold... and relax.",
    duration: '30 sec',
    difficulty: 'Beginner',
    category: ['Falls Prevention', 'Balance', 'Strengthening', 'Wellness', 'Injury Prevention', 'Stretching'],
    goalIntent: ['Improve Balance', 'Improve Coordination', 'Strengthen Hips', 'Improve Stability', 'Maintain Independence', 'Increase Mobility', 'Gentle Side Stretch'],
    symptomFeeling: ['Poor Balance', 'Unsteady Gait', 'Fear of Falling', 'Weakness', 'Hip Instability', 'Side Body Stiffness', 'Core Weakness'],
    bodyPart: ['Full Body', 'Hips', 'Outer Thigh / Hips', 'Core', 'Obliques / Side Body', 'Shoulders', 'Legs'],
    activityContext: ['Walking', 'Reaching', 'Senior Fitness', 'Home Exercises', 'Balance Training', 'Rehab', 'Daily Living Activities'],
    exerciseType: ['Balance Training', 'Coordination', 'Strengthening', 'Stretching', 'Supported Exercise', 'Bodyweight Exercise', 'Lateral Movement / Side Step'],
    difficultyIntensity: ['Beginner', 'Low-Impact', 'Senior-Friendly', 'Rehab', 'Adaptable Intensity']
  },
  {
    videoSrc: "Squat.mp4",
    audioSrc: "The safe sit.m4a",
    thumbnailSrc: "The Safe Sit.jpg",
    thumbnailTimestamp: 4,
    title: 'The Safe Sit',
    description: 'Hold on tight and strengthen your legs safely. This is a great exercise to improve leg and hip strength, stability and great for bone health, particularly if you have arthritis. ',
    dose: 'Aim for 5 to 8 repetitions. If your legs get tired, stop and rest.',
    script: "Stand behind your chair and hold on tight. Push your hips back like you are sitting in a chair behind you. Don't sit all the way down—just touch and come back up.",
    duration: '30 sec',
    difficulty: 'Beginner',
    category: ['Strengthening', 'Wellness', 'Falls Prevention', 'Injury Prevention', 'Balance'],
    goalIntent: ['Strengthen Legs', 'Strengthen Hips', 'Improve Functional Movement', 'Maintain Independence', 'Improve Balance'],
    symptomFeeling: ['Weakness', 'Difficulty Getting Up', 'Poor Balance', 'Fear of Falling', 'Knee Pain / Arthritis', 'Hip Pain'],
    bodyPart: ['Legs', 'Thighs / Quads', 'Glutes / Bottom', 'Hips', 'Knees'],
    activityContext: ['Getting Up from a Chair', 'Senior Fitness', 'Home Exercises', 'Balance Training', 'Daily Living Activities', 'Rehab'],
    exerciseType: ['Strengthening', 'Functional Exercise', 'Squat', 'Bodyweight Exercise', 'Supported Exercise', 'Balance Training'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly', 'Rehab']
  },
  {
    videoSrc: "Calf_Raise.mp4",
    audioSrc: "The tiptoe stand.m4a",
    thumbnailSrc: "The Tiptoe Stand.jpg",
    thumbnailTimestamp: 4,
    title: 'The Tiptoe Stand',
    description: 'Make your lower legs strong and steady to reach high shelves. A wonderful exercise to strengthen your calf muscles to be able to walk further and go up stairs easier. ',
    dose: 'Do 10 repetitions. Pause at the top of each one.',
    script: "Hold the chair firmly. Rise up high onto your tiptoes. Feel tall! Hold it there for a second... and slowly lower your heels back to the ground.",
    duration: '30 sec',
    difficulty: 'Beginner',
    category: ['Strengthening', 'Falls Prevention', 'Balance', 'Wellness', 'Injury Prevention'],
    goalIntent: ['Strengthen Legs', 'Strengthen Ankles', 'Improve Balance', 'Improve Circulation', 'Maintain Independence'],
    symptomFeeling: ['Poor Balance', 'Weakness', 'Ankle Instability', 'Fear of Falling', 'Poor Circulation', 'Leg Cramps'],
    bodyPart: ['Calves / Lower Legs', 'Ankles', 'Feet'],
    activityContext: ['Walking', 'Stair Climbing', 'Reaching', 'Senior Fitness', 'Home Exercises', 'Balance Training', 'Rehab'],
    exerciseType: ['Strengthening', 'Balance Training', 'Bodyweight Exercise', 'Supported Exercise'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Rehab', 'Senior-Friendly']
  },
  {
    videoSrc: "Split Step Squat.mp4",
    audioSrc: "The gentle warrior.m4a",
    thumbnailSrc: "The Gentle Warrior.jpg",
    thumbnailTimestamp: 4,
    title: 'The Gentle Warrior',
    description: "Build the power to walk confidently. The best exercise to improve functional leg strength and stability. Do this regularly and see how better you are able to walk! Recommended for those with arthritis and also those with conditions such as Parkinson's.",
    dose: 'Hold the position for 5 to 10 seconds. Repeat 3 times on each side.',
    script: "Take one step forward and one step back. Hold the chair. Keep your feet flat and gently bend both knees. Feel the strength in your legs. You are a warrior.",
    duration: '30 sec',
    difficulty: 'Beginner',
    category: ['Strengthening', 'Falls Prevention', 'Balance', 'Wellness', 'Injury Prevention'],
    goalIntent: ['Strengthen Legs', 'Strengthen Hips', 'Improve Balance', 'Improve Stability', 'Maintain Independence', 'Improve Functional Movement'],
    symptomFeeling: ['Weakness', 'Poor Balance', 'Fear of Falling', 'Knee Pain / Arthritis', 'Hip Pain', 'Difficulty Walking', 'Difficulty Climbing Stairs'],
    bodyPart: ['Legs', 'Thighs / Quads', 'Glutes / Bottom', 'Hips', 'Knees'],
    activityContext: ['Stair Climbing', 'Walking', 'Senior Fitness', 'Home Exercises', 'Balance Training', 'Rehab', 'Daily Living Activities'],
    exerciseType: ['Strengthening', 'Balance Training', 'Functional Exercise', 'Bodyweight Exercise', 'Supported Exercise', 'Split Stance / Staggered Stance', 'Lunge (Modified)'],
    difficultyIntensity: ['Beginner', 'Low-Impact', 'Senior-Friendly', 'Rehab', 'Adaptable Difficulty']
  },
  {
    videoSrc: "The Pendulum.mp4",
    audioSrc: "The pendulum.m4a",
    thumbnailSrc: "The Pendulum.jpg",
    thumbnailTimestamp: 4,
    title: 'The Pendulum',
    description: "Build the power to walk confidently. The best exercise to improve functional leg strength and stability. Do this regularly and see how better you are able to walk! Recommended for those with arthritis and also those with conditions such as Parkinson's.",
    dose: 'Hold the position for 5 to 10 seconds. Repeat 3 times on each side.',
    script: "Take one step forward and one step back. Hold the chair. Keep your feet flat and gently bend both knees. Feel the strength in your legs. You are a warrior.",
    duration: '30 sec',
    difficulty: 'Beginner',
    category: ['Strengthening', 'Falls Prevention', 'Balance', 'Wellness', 'Injury Prevention'],
    goalIntent: ['Strengthen Hips', 'Improve Balance', 'Improve Stability', 'Strengthen Legs', 'Maintain Independence'],
    symptomFeeling: ['Poor Balance', 'Weakness', 'Fear of Falling', 'Hip Pain / Arthritis', 'Unsteady Gait', 'Hip Instability'],
    bodyPart: ['Hips', 'Outer Thigh / Hips', 'Glutes / Bottom', 'Legs'],
    activityContext: ['Walking', 'Senior Fitness', 'Home Exercises', 'Balance Training', 'Daily Living Activities', 'Rehab'],
    exerciseType: ['Strengthening', 'Balance Training', 'Supported Exercise', 'Bodyweight Exercise', 'Hip Abduction'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly', 'Rehab']
  },
  
  {
    videoSrc: "The Mountain Peak.mp4",
    audioSrc: "The mountain peak.m4a",
    thumbnailSrc: "The Mountain Peak.jpg",
    thumbnailTimestamp: 4,
    title: 'The Mountain Peak',
    description: "Stand tall and steady at the very top. A very simple yet effective balance exercise.",
    dose: 'Hold the position for 5 to 10 seconds. Repeat 3 times on each side.',
    script: "Take one step forward and one step back. Hold the chair. Keep your feet flat and gently bend both knees. Feel the strength in your legs. You are a warrior.",
    duration: '30 sec',
    difficulty: 'Beginner',
    category: ['Falls Prevention', 'Balance', 'Strengthening', 'Wellness', 'Injury Prevention'],
    goalIntent: ['Improve Balance', 'Improve Stability', 'Maintain Independence', 'Strengthen Ankles', 'Strengthen Core', 'Improve Proprioception (Body Awareness)'],
    symptomFeeling: ['Poor Balance', 'Unsteady Gait', 'Fear of Falling', 'Ankle Instability', 'Weakness', 'Dizziness / Vertigo'],
    bodyPart: ['Full Body', 'Ankles', 'Feet', 'Legs', 'Core', 'Abs / Tummy'],
    activityContext: ['Senior Fitness', 'Home Exercises', 'Balance Training', 'Rehab', 'Daily Living Activities', 'Standing Still', 'Waiting in Line'],
    exerciseType: ['Balance Training', 'Static Hold / Isometric', 'Bodyweight Exercise', 'Supported Exercise'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly', 'Rehab', 'Adaptable Difficulty']
  },  
  {
    videoSrc: "The Reverse Gear.mp4",
    audioSrc: "The reverse gear.m4a",
    thumbnailSrc: "The Reverse Gear.jpg",
    thumbnailTimestamp: 4,
    title: 'The Reverse Gear',
    description: "Build the power to walk confidently. The best exercise to improve functional leg strength and stability. Do this regularly and see how better you are able to walk! Recommended for those with arthritis and also those with conditions such as Parkinson's.",
    dose: 'Hold the position for 5 to 10 seconds. Repeat 3 times on each side.',
    script: "Take one step forward and one step back. Hold the chair. Keep your feet flat and gently bend both knees. Feel the strength in your legs. You are a warrior.",
    duration: '30 sec',
    difficulty: 'Beginner',
    category: ['Falls Prevention', 'Balance', 'Strengthening', 'Wellness', 'Injury Prevention'],
    goalIntent: ['Improve Balance', 'Improve Stability', 'Strengthen Legs', 'Strengthen Hips', 'Maintain Independence', 'Improve Coordination'],
    symptomFeeling: ['Poor Balance', 'Unsteady Gait', 'Fear of Falling', 'Weakness', 'Hip Instability'],
    bodyPart: ['Legs', 'Hips', 'Glutes / Bottom', 'Core', 'Ankles'],
    activityContext: ['Walking', 'Daily Living Activities', 'Senior Fitness', 'Home Exercises', 'Balance Training', 'Rehab'],
    exerciseType: ['Balance Training', 'Strengthening', 'Functional Exercise', 'Supported Exercise', 'Bodyweight Exercise', 'Stepping Exercise'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly', 'Rehab']
  },
  
  {
    videoSrc: "The Strong Stride.mp4",
    audioSrc: "The strong stride.m4a",
    thumbnailSrc: "The Strong Stride.jpg",
    thumbnailTimestamp: 4,
    title: 'The Strong Stride',
    description: "Build the power to walk confidently. The best exercise to improve functional leg strength and stability. Do this regularly and see how better you are able to walk! Recommended for those with arthritis and also those with conditions such as Parkinson's.",
    dose: 'Hold the position for 5 to 10 seconds. Repeat 3 times on each side.',
    script: "Take one step forward and one step back. Hold the chair. Keep your feet flat and gently bend both knees. Feel the strength in your legs. You are a warrior.",
    duration: '30 sec',
    difficulty: 'Beginner',
    category: ['Strengthening', 'Falls Prevention', 'Balance', 'Wellness', 'Injury Prevention'],
    goalIntent: ['Strengthen Hips', 'Strengthen Legs', 'Improve Balance', 'Improve Stability', 'Maintain Independence', 'Improve Posture'],
    symptomFeeling: ['Poor Balance', 'Unsteady Gait', 'Fear of Falling', 'Weakness', 'Hip Instability', 'Lower Back Pain', 'Glute Weakness'],
    bodyPart: ['Glutes / Bottom', 'Hamstrings / Back of Thigh', 'Hips', 'Legs', 'Lower Back'],
    activityContext: ['Walking', 'Standing', 'Senior Fitness', 'Home Exercises', 'Balance Training', 'Rehab', 'Daily Living Activities'],
    exerciseType: ['Strengthening', 'Balance Training', 'Supported Exercise', 'Bodyweight Exercise', 'Hip Extension'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly', 'Rehab']
  },
  
  {
    videoSrc: "The Water Tester.mp4",
    audioSrc: "The water tester.m4a",
    thumbnailSrc: "The Water Tester.jpg",
    thumbnailTimestamp: 4,
    title: 'The Water Tester',
    description: "Build the power to walk confidently. The best exercise to improve functional leg strength and stability. Do this regularly and see how better you are able to walk! Recommended for those with arthritis and also those with conditions such as Parkinson's.",
    dose: 'Hold the position for 5 to 10 seconds. Repeat 3 times on each side.',
    script: "Take one step forward and one step back. Hold the chair. Keep your feet flat and gently bend both knees. Feel the strength in your legs. You are a warrior.",
    duration: '30 sec',
    difficulty: 'Beginner',
    category: ['Strengthening', 'Falls Prevention', 'Balance', 'Wellness', 'Injury Prevention'],
    goalIntent: ['Strengthen Legs', 'Strengthen Hips', 'Improve Balance', 'Improve Stability', 'Maintain Independence', 'Improve Coordination'],
    symptomFeeling: ['Poor Balance', 'Unsteady Gait', 'Fear of Falling', 'Weakness', 'Hip Instability', 'Difficulty Moving Sideways', 'Knee Pain / Arthritis'],
    bodyPart: ['Hips', 'Outer Thigh / Hips', 'Inner Thigh / Groin', 'Glutes / Bottom', 'Thighs / Quads', 'Knees', 'Legs'],
    activityContext: ['Walking', 'Navigating Crowds', 'Stepping Over Obstacles', 'Senior Fitness', 'Home Exercises', 'Balance Training', 'Rehab', 'Daily Living Activities'],
    exerciseType: ['Strengthening', 'Balance Training', 'Functional Exercise', 'Supported Exercise', 'Bodyweight Exercise', 'Lateral Movement / Side Step'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly', 'Rehab']
  },

  {
    videoSrc: "Step to side + Knee bend.mp4",
    audioSrc: "The crane dip.m4a",
    thumbnailSrc: "The Crane Dip.jpg",
    thumbnailTimestamp: 4,
    title: 'The Crane Dip',
    description: 'Be steady and strong like a bird in the water. A beautiful compound exercise to improve lower limb stability and balance',
    dose: 'Try 8 gentle dips on each leg. Do not go too deep.',
    script: "Lift one foot slightly off the ground. Bend your standing knee just a tiny bit—a small dip. Straighten back up. Stay balanced like a crane.",
    duration: '30 sec',
    difficulty: 'Beginner',
    category: ['Strengthening', 'Falls Prevention', 'Balance', 'Wellness', 'Injury Prevention'],
    goalIntent: ['Strengthen Legs', 'Strengthen Hips', 'Improve Balance', 'Improve Stability', 'Maintain Independence', 'Improve Coordination'],
    symptomFeeling: ['Poor Balance', 'Unsteady Gait', 'Fear of Falling', 'Weakness', 'Hip Instability', 'Difficulty Moving Sideways', 'Knee Pain / Arthritis'],
    bodyPart: ['Hips', 'Outer Thigh / Hips', 'Inner Thigh / Groin', 'Glutes / Bottom', 'Thighs / Quads', 'Knees', 'Legs'],
    activityContext: ['Walking', 'Navigating Crowds', 'Stepping Over Obstacles', 'Senior Fitness', 'Home Exercises', 'Balance Training', 'Rehab', 'Daily Living Activities'],
    exerciseType: ['Strengthening', 'Balance Training', 'Functional Exercise', 'Supported Exercise', 'Bodyweight Exercise', 'Lateral Movement / Side Step'],
    difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly', 'Rehab']
  }
];